// extracted by mini-css-extract-plugin
export default {"join__container":"joincampfire_join__container__+o7UT","title":"joincampfire_title__CrSg4"};